export type CloudinaryType = {
    public_id: string;
    url: string;
    tags: string[];
    type: 'upload' | 'private' | 'authenticated';
    bytes: number;
    width: number;
    format: string;
    height: number;
    version: number;
    duration: null | number;
    metadata: [];
    context?: {
        custom?: { [key: string]: string };
    };
    created_at: string;
    secure_url: string;
    original_url: string;
    resource_type: string;
    raw_transformation: string;
    original_secure_url: string;
};

export function hasCldImage(fields: any): fields is { cloudinaryMedia: Array<CloudinaryType> } {
    return fields && 'cloudinaryMedia' in fields;
}
export function hasCldIcon(fields: any): fields is { iconCloudinary: Array<CloudinaryType> } {
    return fields && 'iconCloudinary' in fields;
}
